module.exports = __webpack_public_path__ + "assets/icons/translated_with_DeepL_ES-13c2.svg";